import React, { useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { config } from '../Constants'
import './Data.css'
import { useTranslation } from "react-i18next";
import CheckIcon from '@mui/icons-material/Check';
import { reportUnsavedChanges } from './UnsavedChanges';


export function EditAndSaveButton({ mode, onEdit, onSave, onDelete, onCheck }) {
    /** TODO: rename now that delete is also possible */
    /**
     * mode: 'edit', 'saved', 'delete'
     */
    return <div className="save-edit-button">
        {
            (mode === 'saved') ? <div className='edit-icon'><EditIcon onClick={() => onEdit()} /></div> :
                (mode === 'edit') ? <div className='save-icon'><SaveIcon onClick={() => onSave()} /></div> :
                    (mode === 'delete') ? <div className='delete-icon'><DeleteIcon onClick={() => onDelete()} /></div> :
                        (mode === 'check') ? <div className='edit-icon' onClick={() => onCheck()}><CheckIcon /></div> :
                            <div className='edit-icon' style={{ visibility: "hidden" }}><EditIcon /></div>
        }
    </div>
}


export function SaveButton({ saved, callback, guardId }) {
    const [pending, setPending] = useState(false)
    const [error, setError] = useState(false)
    const { t } = useTranslation('app');

    // Views pass a guardId so the app can block navigation while this button
    // shows "unsaved" (TAK-15). The registry entry is cleared on unmount.
    useEffect(() => {
        if (!guardId) return;
        reportUnsavedChanges(guardId, !saved);
        return () => reportUnsavedChanges(guardId, false);
    }, [guardId, saved]);

    // A save that resolves to `false` (or rejects) used to leave the button on
    // "Saving..." forever — rage-click bait (TAK-12). Callbacks that don't
    // return a promise keep working: they just release the pending state.
    const showError = () => {
        setError(true)
        setTimeout(() => setError(false), 4000)
    }

    const handleClick = () => {
        if (pending) return // absorb extra clicks while a save is running
        if (saved) { callback(); return } // keep legacy behaviour for "already saved" buttons
        setError(false)
        setPending(true)
        try {
            Promise.resolve(callback()).then((success) => {
                setPending(false)
                if (success === false) showError()
            }).catch(() => {
                setPending(false)
                showError()
            })
        } catch (e) {
            setPending(false)
            showError()
        }
    }

    return <div onClick={handleClick}
        className={"save-button" + (saved ? " saved" : " unsaved") + (pending ? " saving" : "") + (error ? " save-error" : "")}
        title={error ? t('edit.save-failed') : undefined}>
        {saved ?
            <>
                <div>{t('edit.saved')}</div>
                <div><CheckIcon /></div>
            </>
            :
            <>
                {pending ? <div>{t('edit.saving')}</div>
                    : error ? <div>{t('edit.save-failed')}</div>
                        :
                        <>
                            <div>{t('edit.save')}</div>
                            <SaveIcon />
                        </>
                }
            </>}
    </div>
}